/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Form,
  message,
  Select,
  DatePicker,
  Spin,
  Upload,
} from "antd";
import uploadLogo from "../../../../../assests/images/bx_upload.svg";
import { APIs, getPremiseId, getToken } from "../../../../../utils/worker";
import { useNavigate } from "react-router-dom";
import API from "../../../../../api";
import urls from "../../../../../api/urls";
import axios from "axios";
import moment from "moment";
import { dateFormateSlashFormat } from "../../../../../utils";
const { UPLOAD_CLIENT_DOC, LEAD_CLIENT_DOCUMENT, UPLOAD_LEAD_CLIENT_FILE } =
  urls;
const token = getToken();
const { Dragger } = Upload;
const userId = JSON.parse(localStorage.getItem("userId"));

export const AddAgreement = ({
  getData,
  handleStepsChange = () => {},
  goBackStep = () => {},
}) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileNew, setFileNew] = useState();

  useEffect(() => {
    if (getData?.documentDetails?.startDate) {
      form.setFieldValue(
        "validFrom",
        moment(getData?.documentDetails?.startDate, dateFormateSlashFormat)
      );
      setFromDate(getData?.documentDetails?.startDate);

      form.setFieldValue(
        "validTo",
        moment(
          getData?.documentDetails?.endDate || "20/02/2021",
          dateFormateSlashFormat
        )
      );
      setToDate(getData?.documentDetails?.endDate);
    }
  }, [getData]);

  const disabledDate = (current) => {
    return current < moment().startOf("day");
  };

  const disabledDateNext = (current) => {
    return current <= moment(fromDate, "DD/MM/YYYY").endOf("day");
  };

  const changeFromDate = (date, dateString) => {
    setFromDate(dateString);
    form.setFieldValue("validTo", null);
  };

  useEffect(() => {
    let doc = getData?.documentDetails;
    let temp = [];
    if (doc?.fileName) {
      let name = doc?.fileName?.toString("")?.split("/");
      temp.push({
        name: name[name.length - 1],
        url: doc?.fileName,
        id: doc?.fileId,
      });
      setFileList([...temp]);
    }
  }, [getData]);

  const removeFile = (fileList_) => {
    let filteredData = fileList?.filter((e) => e.id !== fileList_?.id);
    message.success("File deleted successfully");
    setFileList([...filteredData]);
    setFileNew(null);
  };

  const fileRequestHandle = async (e) => {
    setFileNew(e);
    if (e?.name == fileNew?.name) {
      message.error("This file is already uploaded.");
    } else {
      let clientLeadId = localStorage.getItem("clientLeadId");
      const form = new FormData();
      form.set("file", e);

      try {
        setLoading(false);

        const response = await axios.post(UPLOAD_LEAD_CLIENT_FILE, form, {
          headers: {
            //"Content-Type": "multipart/form-data",
            Authorization: token,
            clientId: clientLeadId || 12,
          },
        });
        if (response.status === 200) {
          setLoading(false);

          let name = response?.data?.data?.filePath?.toString("")?.split("/");
          setFileList([
            {
              name: name[name?.length - 1],
              url: response.data.data.filePath,
              id: response.data.data.id,
            },
          ]);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        message.error(error?.response?.data?.message);
      }
    }
  };

  const submitDocData = async () => {
    setLoading(true);
    if (fileList?.length === 0) {
      message.error("Please upload a file.");
      setLoading(false);
    } else {
      if (getData?.clientDocument?.length > 0) {
        navigate("/dp-lead-generation-list");
        localStorage.removeItem("clientLeadId");
        setLoading(false);
      } else {
        let clientLeadId = localStorage.getItem("clientLeadId");
        let payload = [];
        fileList.map((e) => {
          payload.push({
            fileName: e?.url,
            fileId: e?.id,
            startDate: fromDate,
            endDate: toDate,
          });
        });
        let response = await API.Api(
          LEAD_CLIENT_DOCUMENT + clientLeadId
        ).patchCustomHeader(payload, {
          "SMCS-PREMISE-ID": userId?.userInfo?.premiseId,
        });
        if (response.status) {
          message.success(
            "Document added successfully, once details will approved by HO you can proceed further. Please wait for 24 hours."
          );
          localStorage.removeItem("clientLeadId");
          setLoading(false);
          navigate("/quotation-list/" + clientLeadId);
        } else {
          message.error("Internal Server Error");
          setLoading(false);
        }
      }
    }
  };

  return (
    <Spin spinning={loading}>
      <Form
        className="global-form pl-4 pr-4 p-2"
        layout="vertical"
        form={form}
        scrollToFirstError={{
          behavior: "smooth",
          block: "center",
          inline: "center",
        }}
        onFinish={submitDocData}>
        <Row gutter={20} className="mt-1 global-form-row">
          <Col span={24} className="mb-1">
            <span className="master-title">Add Documents</span>
            <hr className="divider" />
          </Col>
        </Row>
        <Row gutter={40} className="mt-1 global-form-row">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item
              name="pancardUrl"
              label="Upload document"
              rules={[
                {
                  required:
                    getData?.documentDetails?.fileName === null ? true : false,
                  message: "Please upload a file",
                },
              ]}>
              <div className="one-row">
                <Dragger
                  className=""
                  maxCount={1}
                  disabled={
                    getData?.documentDetails?.fileName === null ? true : false
                  }
                  onRemove={removeFile}
                  beforeUpload={(file) => {
                    let type = file.type.split("/")[1];
                    if (file.size / 1024 / 1024 > 5) {
                      message.warning("Maximum upload file size 5 MB.");
                    } else if (
                      type !== "jpeg" &&
                      type !== "png" &&
                      type !== "pdf"
                    ) {
                      message.warning("Only PNG, JPEG, PDF are allowed.");
                    } else {
                      fileRequestHandle(file);
                    }
                  }}
                  multiple={false}
                  fileList={fileList}
                  style={{ borderRadius: "10px", padding: "10px" }}>
                  <Row>
                    <Col
                      span={8}
                      className="m-auto"
                      style={{ borderRight: "1px solid #CECECE" }}>
                      <img
                        src={uploadLogo}
                        className="Upload-logo"
                        style={{ width: "40px", height: "40px" }}
                      />
                    </Col>
                    <Col span={16} className="f-13">
                      <p>Click to upload or drag and drop</p>
                      {/* <p>Maximum file size 10 MB</p> */}
                      <p>
                        Supported file type: PDF, JPEG, PNG and Max 10MB file
                        size
                      </p>
                    </Col>
                  </Row>
                </Dragger>
              </div>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name="validFrom"
                  label="Start date"
                  // initialValue={moment(fromDate, dateFormat)}
                  rules={[
                    {
                      required: true,
                      message: "Please select valid from",
                    },
                  ]}>
                  <DatePicker
                    disabledDate={disabledDate}
                    format={dateFormateSlashFormat}
                    onChange={(date, dateString) =>
                      changeFromDate(date, dateString)
                    }
                    disabled={
                      getData?.clientDocument?.length > 0 ? true : false
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name="validTo"
                  label="Valid till"
                  // initialValue={moment(toDate, dateFormat)}
                  rules={[
                    {
                      required: true,
                      message: "Please select valid to",
                    },
                  ]}>
                  <DatePicker
                    disabledDate={disabledDateNext}
                    disabled={getData?.clientDocument?.length > 0}
                    format={dateFormateSlashFormat}
                    onChange={(date, dateString) => setToDate(dateString)}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
        <hr className="divider" />
        <div className="d-flex flex-end p-1">
          <Button className="cancel-btn ml-1 w-15" onClick={goBackStep}>
            BACK
          </Button>
          {/* <Button htmlType="submit" className="save-btn w-15 ml-1">
            SUBMIT
          </Button> */}
          <Button
            htmlType="submit"
            // onClick={() => navigate("/quotation-list")}
            className="save-btn w-15 ml-1">
            SUBMIT
          </Button>
        </div>
      </Form>
    </Spin>
  );
};

// export default AddRateCard;

export default AddAgreement;
